import {TileBaseComponent} from '../../tile-base.component';
import {Component, ElementRef, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Tile} from '../../../../../../shared/models/tile';
import {TileMinimalElemSetup,} from '../../../../../../shared/models/tile-template/interfaces';
import {TilesService} from '../../../../../../core/services/tiles.service';
import {TilePollingService} from '../../../../../../core/services/tile-polling.service';
import {ShadeToolsService} from '../../../../../../core/services/shade-tools.service';
import {AlarmsService} from '../../../../../../core/services/alarms.service';
import {TileHistoryService} from '../../../../../../core/services/tile-history.service';
import {SessionService} from '../../../../../../core/services/session.service';
import { Subject } from 'rxjs';
import { PermissionsService } from 'src/core/services/permissions.service';
import { MotiChatService } from 'src/moti/services/moti-chat.service';
import { ViewportIntersectionService } from '../../../../../../core/services/viewport-intersection.service';
import { trigger, transition, style, animate } from '@angular/animations';


@Component({
    selector: 'motn-tile-data-point',
    templateUrl: './tile-data-point.component.html',
    styleUrls: ['./tile-data-point.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    animations: [
      trigger('fadeInOut', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('250ms ease-in-out', style({ opacity: 0.4 }))
        ]),
        transition(':leave', [
          animate('250ms ease-in-out', style({ opacity: 0 }))
        ])
      ])
    ]
})
export class TileDataPointComponent extends TileBaseComponent implements OnInit, OnDestroy {
  @Input() rawTile: Tile;
  @Input() elemDef: TileMinimalElemSetup;

  @Output()
  togglePopoverTile = new Subject<Tile>();

  get displayUnits(): string {
    // showing units only for not empty values
    if (this.displayValue == '0' || !!this.displayValue) {
      return this.tile.getUnitsLabel();
    }
    return '';
  };

  constructor(
    protected tilesService: TilesService,
    protected tilePollingService: TilePollingService,
    protected shadeTools: ShadeToolsService,
    protected alarmsService: AlarmsService,
    protected tileHistoryService: TileHistoryService,
    protected permissionsService: PermissionsService,
    protected session: SessionService,
    protected motiChatService: MotiChatService,
    protected elementRef: ElementRef,
    protected viewportService: ViewportIntersectionService,
  ) {
    super(tilesService, tilePollingService, shadeTools, alarmsService, tileHistoryService, permissionsService, session, motiChatService, elementRef, viewportService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }


  protected onDestroy(): void {
  }

  protected onInit(): void {
  }

  togglePopover(): void {
    this.togglePopoverTile.next(this.rawTile);
  }
}
